export default __webpack_public_path__ + "static/2286-c8aad71541854c1e547ac7a2136d6e0f.gif";